import styled from 'styled-components';

export const DownloadBannerSection = styled.section`
  background-color: ${(props) => (props?.color ? props?.color : '#fff0f0')};
  display: grid;
  grid-template-columns: 60% 40%;
  margin: 20px 0;
  padding: 0 12px;

  .leftSection {
    max-width: 80%;
    margin: 10px auto;

    @media (max-width: 720px) {
      max-width: 100%;
    }
  }

  img {
    width: 100%;
    max-width: 104px;

    @media (max-width: 720px) {
      max-width: 84px;
    }
  }
  &.lowOpacity {
    opacity: 0.4;
  }
`;

export const BannerMobileImage = styled.div`
  img {
    width: 100%;
    height: 100%;
    max-width: 170px;
    padding-top: 0;
    padding-top: 26px;
  }
`;

export const BannerPara = styled.p`
  font-size: 15px;
  font-weight: 500;
  padding: 16px 0;
  color: rgb(0 0 0 / 87%);
  padding: 16px 12px 16px 0;
`;

export const DownloadMylo = styled.div`
  font-weight: 700;
  font-size: 17px;
  color: #000;
  margin-bottom: 10px;
  padding-right: 12px;

  img {
    margin-left: 3px;
    margin-right: 6px;
    width: 48px;
    height: 100%;
  }
`;
